import TabDOM from '@/scripts/core/TabDOM';

document.addEventListener('DOMContentLoaded', () => {
	new TabDOM();
})
